import React, { useState, useRef, useEffect } from "react";
import CommonInputContainer from "./CommonInputContainer";

function CommonSearchableDropdownInput({
  options = [],
  value,
  placeholder,
  onChange,
  label,
  error,
  className,
  optionObject = false,
  searchDefault = "",
  onSearchChange,
  loading,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const dropdownRef = useRef(null);

  const handleToggle = () => {
    setIsOpen((prev) => !prev);
    setSearch("");
  };

  const handleOptionClick = (selected) => {
    handleToggle();
    if (onChange) {
      onChange(selected);
    }
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setSearch(searchDefault);
  }, [searchDefault]);

  useEffect(() => {
    onSearchChange?.(search);
  }, [search]);

  const filteredOptions = optionObject
    ? options.filter((option) =>
        option.label.toLowerCase().includes(search.toLowerCase())
      )
    : options.filter((option) =>
        option.toLowerCase().includes(search.toLowerCase())
      );

  const selectedLabel = optionObject
    ? options.find((opt) => opt.value === value)?.label
    : value;

  return (
    <CommonInputContainer
      label={label}
      className={className}
      error={error && !value}
    >
      <div ref={dropdownRef} className="relative w-full">
        <div
          onClick={!isOpen ? handleToggle : undefined}
          className={`w-full h-12 items-center px-4 border ${
            error && !value ? "border-red-600" : "border-[#DBDBDB]"
          } bg-white rounded-lg placeholder:text-[#A4B1C1] focus:outline-none flex justify-between cursor-pointer`}
        >
          {/* Toggle between input and span */}
          {isOpen ? (
            <input
              autoFocus
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder={placeholder}
              className="flex-1 outline-none text-black placeholder:text-[#A4B1C1] text-sm"
            />
          ) : (
            <span className={`${value ? "text-black" : "text-[#A4B1C1]"}`}>
              {selectedLabel || placeholder}
            </span>
          )}

          {loading ? (
            <div className="primaryLoader"></div>
          ) : (
            <img
              src="/IconChevronDown.svg"
              alt=""
              className={`w-3 transition-all object-contain ${
                isOpen ? "rotate-180" : ""
              }`}
            />
          )}
        </div>

        {isOpen && (
          <ul className="absolute w-full mt-2 bg-white border border-[#DBDBDB] rounded-lg shadow-md z-10 overflow-hidden max-h-60 overflow-auto">
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option, index) => (
                <li
                  key={index}
                  onClick={() =>
                    handleOptionClick(optionObject ? option.value : option)
                  }
                  className="px-4 py-2 hover:bg-[#F0F4F8] cursor-pointer whitespace-normal"
                >
                  {optionObject ? option.label : option}
                </li>
              ))
            ) : (
              <li className="px-4 py-2 text-sm text-gray-400">
                No options found
              </li>
            )}
          </ul>
        )}
      </div>
    </CommonInputContainer>
  );
}

export default CommonSearchableDropdownInput;
